import {Endereco} from "./endereco";
import {BaseBean} from "./base-bean";

export class Cadastrao extends BaseBean {

    public _explicitType: string = 'br.com.sgsistemas.cotacao.cotacaoweb.beans.Cadastrao';
    public nome: string;
    public dataCadastro: string;
    public foneComercial: string;
    public email: string;
    public situacao: string;
    public endereco: Endereco;
    
    constructor(id?: number,
                nome?: string,
                dataCadastro?: string,
                foneComercial?: string,
                email?: string,
                situacao?: string,
                endereco?: Endereco) {
        super(id);
        this.nome = nome;
        this.dataCadastro = dataCadastro;
        this.foneComercial = foneComercial;
        this.email = email;
        this.situacao = situacao;
        this.endereco = endereco;
    }

}
